/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
GOOGLE_processor_version: 294144208
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei/useGLTF'

export default function Model(props) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/models/Slide/Slide.gltf')
  return (
    <group ref={group} {...props} dispose={null}>
      <group position={[-0.02, 1.78, 0.36]}>
        <group position={[0.02, -1.78, -0.36]}>
          <mesh material={materials.Slide_Mat} geometry={nodes['node-0'].geometry} />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/models/Slide/Slide.gltf')
